export type EditCompanyApiSettingsDto = {
    apiStatus: ApiStatus | null;
    companyId: string | null;
}

export enum ApiStatus {
    "Disabled",
    "Enabled",
}
